import React from 'react';

import {
  Container,
  Wrapper,
  Image,
  Title,
  ContinueButton,
  MainContent,
} from './elements';
import { useText, useConfig, useLink } from 'common/hooks';

export default function CheckEmail(): React.ReactElement {
  const t = useText();
  const link = useLink();
  const { staticUrl } = useConfig();

  return (
    <Container>
      <Wrapper>
        <MainContent>
          <Image alt={''} src={`${staticUrl}/images/sad_earth.png`} />
          <Title as={'h1'}>
            {t('authentication.errors.invalid_action_code')}
          </Title>
          <ContinueButton href={link('forgotPassword')}>
            {t('authentication.resend_email')}
          </ContinueButton>
        </MainContent>
      </Wrapper>
    </Container>
  );
}
